
// Re-export the global Customer type for consistency
export type { Customer } from "@/lib/types";

export type CompanyMember = {
  user_id: string;
  first_name: string | null;
  last_name: string | null;
};

export const sortOptions = [
  { value: "name", label: "First Name" },
  { value: "last_name", label: "Last Name" },
  { value: "created_at", label: "Date Added" },
  { value: "updated_at", label: "Last Modified" },
];

export const socialMediaSources = ["Facebook", "Instagram", "LinkedIn", "Social Media"];
export const referralSources = ["Word of Mouth", "Referral"];
export const advertisingSources = ["Car Branding", "House Branding"];
